import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Directive({
  selector: 'input[type="number"]',
  standalone: true,
})
export class DisableInputSpinEventsDirective {
  @HostListener('wheel', ['$event']) onWheel(e: WheelEvent): void {
    e.preventDefault();
  }

  @HostListener('keydown', ['$event']) onKeydown(e: any): void {
    if (+e.which === 38 || +e.which === 40) {
      e.preventDefault();
    }
  }

  constructor(private el: ElementRef, private renderer: Renderer2, private sanitizer: DomSanitizer) {
    this.renderer.addClass(this.el.nativeElement, 'disable-input-spin-buttons');
  }
}
